import _ from "lodash";
/** external */
import React, { Fragment, useEffect, useRef } from "react";
import { Badge, Tooltip } from "@toddle-edu/ds-web";
import classNames from "classnames";

/** internal */
import { useI18n } from "Hooks";
import { useIntersectionObserver } from "Utils";

/** relative */
import classes from "./ShortcutsSection.scss";

const ShortcutsSection = props => {
  const {
    section,
    parentContainerRef,
    sectionHeaderRefs,
    setSidebarOption,
    isScrollManual,
  } = props;
  const { id, label, icon: Icon, shortcuts } = section;
  const { t } = useI18n(["common"]);

  const sectionHeaderRef = useRef();
  sectionHeaderRefs.current[id] = sectionHeaderRef;

  const isHeaderVisible = useIntersectionObserver(sectionHeaderRef, {
    threshold: 1,
    root: parentContainerRef.current,
  });

  useEffect(() => {
    if (isHeaderVisible && isScrollManual.current) {
      setSidebarOption(id);
    }
  }, [isHeaderVisible]);

  const shortcutNameHeaderClasses = classNames(
    "text-label",
    classes.shortcutNameHeader
  );
  const shortcutKeysHeaderClasses = classNames(
    "text-label",
    classes.shortcutKeysHeader
  );
  const shortcutSubtitleClasses = classNames(
    "text-body-s",
    classes.shortcutSubtitle
  );

  const getShortcutBadges = shortcutKeys => {
    return _.map(shortcutKeys, (key, index) => (
      <Fragment key={key}>
        {index !== 0 ? "+" : null}
        <Badge
          dsVersion="2.0"
          value={key}
          type="shortcut"
          shape="square"
          size="xx-small"
        />
      </Fragment>
    ));
  };

  return (
    <div className={classes.container}>
      <table className={classes.section}>
        <thead ref={sectionHeaderRef}>
          <tr className={classes.separator}>
            <th className={shortcutNameHeaderClasses}>
              <Icon />
              {label}
            </th>

            <th className={shortcutKeysHeaderClasses}>
              {t("common:shortcut")}
            </th>
          </tr>
        </thead>

        <tbody>
          {_.map(shortcuts, (shortcut, index) => {
            const { id, label, subtitle, keys } = shortcut;

            const rowClasses = classNames({
              [classes.separator]: index < _.size(shortcuts) - 1,
            });

            return (
              <tr className={rowClasses} key={id}>
                <td className={classes.shortcutNameCell}>
                  <Tooltip dsVersion="2.0" tooltip={label} placement="top">
                    <div className={classes.shortcutLabel} dir="auto">
                      {label}
                    </div>
                  </Tooltip>

                  {subtitle ? (
                    <Tooltip dsVersion="2.0" tooltip={subtitle}>
                      <div className={shortcutSubtitleClasses}>{subtitle}</div>
                    </Tooltip>
                  ) : null}
                </td>

                <td className={classes.shortcutKeysCell}>
                  {!_.isArray(keys[0])
                    ? getShortcutBadges(keys)
                    : _.map(keys, (shortcutKeys, index) => {
                        return (
                          <Fragment key={index}>
                            {index !== 0
                              ? t("common:lowercase", {
                                  text: t("common:then"),
                                })
                              : null}
                            {getShortcutBadges(shortcutKeys)}
                          </Fragment>
                        );
                      })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ShortcutsSection;
